import noUiSlider from 'nouislider';

export default {
	init: function() {
		$('.range-slider').each(this.initializeRange);
		$('.range-swiper').each(this.initializeSwiper);

	},
	initializeSwiper: (idx, el) => {
		const $el = $(el)
			, $nav = $el.siblings('.slider__tabs');

		el.swiper = new Swiper(el, {
			// autoHeight: true,
			allowTouchMove: false,
		});

		$nav.on('click', 'a', e => {
			e.preventDefault();

			$nav.find('li a').removeClass('tab--active');
			el.swiper.slideTo($nav.find('li').index($(e.currentTarget).parent()));
			$(e.currentTarget).addClass('tab--active');
		});
	},
	initializeRange: (idx, el) => {

		const min = $(el).data('min')
			, max = $(el).data('max');

		let slider = null;

		slider = noUiSlider.create(el, {
			start: 40,
			step: 1,
			connect: [true, false],
			range: {
				'min': min,
				'max': max
			}
		});

		slider.on('update', function(val) {
			let value = parseInt(val);
			let finalValue = 0;

			if(typeof $(slider.target).data('expression') !== 'undefined'){
				let expression = $(slider.target).data('expression');
				expression = expression.replace('{num}', value);
				try {
					finalValue = eval(expression).toLocaleString('en-GB');
				} catch(e){
					finalValue = 'N/A';
				}
			}

			value = value.toLocaleString('en-GB');

			value = value.split('.')[0];
			finalValue = finalValue.split('.')[0];


			$(slider.target).siblings('.slider__input-amount').find('.slider-value').text(`£ ${ finalValue } `);
			$(slider.target).siblings('.slider__input-final').find('.value').text(`£ ${ value } `);

			if($(slider.target).find('.noUi-popup').length) {
				$(slider.target).find('.noUi-popup').find('.amount').text(`£ ${ value } `);
			} else {
				$(slider.target).find('.noUi-handle').append(`
					<div class="noUi-popup">
						<span class="h3 amount">£${ value } </span>
						<span>Investment value</span>
					</div>
				`);
			}
		});
	}
}
